import Title_ru_RU_Class from "@/core/misc/decorators/Title_ru_RU_Class";
import Order             from '@/domains/Orders/Order';
import PreorderPosition  from "@/domains/Preorders/PreorderPosition";

import type Offer        from "@/domains/Offers/Offer";
import type Demand       from "@/domains/Demand/Demand";
import type OrderCategory from "@/domains/Orders/OrderCategory";

/**
 * Preorder — фронтовая обёртка над Order для предзаказов.
 *
 * На бэкенде отдельной модели нет: предзаказ — это Order с isPreorder = true.
 * Класс нужен для двух вещей:
 * 1. Типизация — positions это PreorderPosition[], а не OrderPosition[].
 * 2. Подмена класса позиции в фабриках родителя.
 *
 * Предзаказных полей здесь нет: документ существует один раз, в момент
 * создания, дальше вся работа идёт с позицией — там они и живут.
 */
@Title_ru_RU_Class('Предзаказ')                     // preorder → Preorder
class Preorder extends Order {

    declare public positions: PreorderPosition[];

    static fromNew(orderCategory: OrderCategory, result = new Preorder()): Preorder {
        super.fromNew(orderCategory, result);

        result.requisites.isPreorder = true;

        return result;
    }

    static fromOffer(offer: Offer, demand: Demand | null = null, result = new Preorder()): Preorder {
        super.fromOffer(offer, demand, result);

        result.requisites.isPreorder = true;

        return result;
    }

    /** Фабрики родителя создают позицию предзаказа, а не позицию заказа. */
    protected static override createPositionFromOffer(offer: Offer, demand: Demand | null): PreorderPosition {
        return PreorderPosition.fromOffer(offer, demand);
    }
}

export default Preorder;